import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";
import OptionsMap from "%/dynamic-component-editor/options/options-map";
import { camelToTitleCase } from "@bloglovin/vue-framework";

import { MenuConstants } from "@vcl";

// Lazy store resolution: a module-scope import here closes a cycle
// (stores -> components -> mixins -> classes). See scripts/find-import-cycles.py.
// eslint-disable-next-line global-require
const useDynamicComponentEditorStore = (...args) => require("%/dynamic-component-editor/stores/dynamic-component-editor").default(...args);


export default class OptionVariables extends BaseRootOption {
  static useSubtitle = true;
  static hideOptionTool = true;

  static userInterfaceComponent = data => {
    if (!data) {
      return {
        label: "Variables",
        component: inspectorTools.OPTION_GROUP,
        useSubtitle: true,
        hideOptionTool: true,
        useCustomLabel: true,
        canUpdateLabel: true,
        useVerticalOrientation: true,
        props: {
          optionVariables: {},
          emptyText: "No variables found",
          title: "Variables",
          option: {
            bundleOptions: [],
          },
        },
      };
    }

    const variables = data["variables"] || {};

    const variableKeys = Object.keys(variables);
    const optionValues = {};
    const optionsToRender = variableKeys.map(key => {
      const value = variables[key];
      const optionType = value.type;

      const optionsMap = OptionsMap.optionsMap;
      const optionClass = optionsMap[optionType.split("")[0].toLowerCase() + optionType.slice(1)];

      const optionInstance = new optionClass();
      optionInstance.optionKey = key;
      optionInstance.overrideLabel = value.label;
      if (this.useSubtitle) {
        optionInstance.subtitle = optionType;
      }
      optionInstance._shouldHideOptionTool = this.hideOptionTool;
      optionValues[`default.${key}`] = value.value;

      return optionInstance;
    });

    const menuItems = Object.keys(OptionsMap.optionsMap).map(item => {
      return {
        name: item,
        label: camelToTitleCase(item),
        actionType: MenuConstants.ACTION_TYPE_BUTTON_CLICK,
        actionValue: item,
      };
    });

    return {
      label: "Variables",
      component: inspectorTools.OPTION_GROUP,
      useSubtitle: true,
      hideOptionTool: true,
      useCustomLabel: true,
      canUpdateLabel: true,
      useVerticalOrientation: true,
      props: {
        optionValues,
        optionVariables: {},
        option: {
          bundleOptions: optionsToRender,
        },
        title: "Variables",
        menuItems: menuItems,
        searchableMenu: true,
        emptyText: "No variables found",
        manualUpdate: true,
        canUpdateOptionSettings: true,
        optionSettingsComponent: inspectorTools.UPDATE_OPTION_VARIABLE,
        handleMenuItemClick(value) {
          // iMenu emits the full item descriptor (`{name, actionType,
          // actionValue, ...}`), not the bare `actionValue`. Unwrap it
          // defensively so we look up the OptionsMap entry with the
          // string key — without this the lookup returned undefined and
          // the click silently did nothing.
          const key = typeof value === "string" ? value : value?.actionValue ?? value?.name;
          const option = OptionsMap.optionsMap[key];
          if (!option) {
            return;
          }
          useDynamicComponentEditorStore().convertOptionToVariable(option);
        },
        handleRemove(key) {
          useDynamicComponentEditorStore().removeTemplateVariable(key);
        },
        sideEffect: (data, type, dynamicComponent) => {
          if (type === "value") {
            dynamicComponent.updateVariableDefaultValue(data.option.optionKey, data.value);
          } else if (type === "label") {
            dynamicComponent.updateVariableLabel(data.option.optionKey, data.label);
          }

          if (type === "value") {
            setTimeout(() => {
              dynamicComponent.reprocessAllElements();
            }, 0);
          }
        },
      },
    };
  };

  static defaultValue = {};
}
